import {combineReducers} from "redux";
import clientReducer from "./clientReducer";
import categoryReducer from "./categoryReducer";

const reducers = combineReducers({
    client: clientReducer,
    categories: categoryReducer
})

export default reducers;